import React, {useContext, useEffect, useState} from "react";
import AppContext from "../context/AppContext";
import DirectoryList from "../components/DirectoryList";
import VideoList from "../components/VideoList";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMinus, faPlus} from "@fortawesome/free-solid-svg-icons";
import ClipList from "../components/ClipList";
import ContinueWatching from "../components/ContinueWatching";
import TagManagement from "../components/TagManagement";
import './FileBrowser.scss'

export default () => {
    const location  = useLocation()
    const navigate  = useNavigate()

    const defaultTerm = location.pathname.split('/search/').pop() || ''

    const { dirLoading, directories, files, currentDir, loadDirectory, tags, maxFiles } = useContext(AppContext)

    const [searchTerm,    setSearchTerm]    = useState(defaultTerm)
    const [tagSearchTerm, setTagSearchTerm] = useState('')
    const [tagManageMode, setTagManageMode] = useState(false)

    const isTagList    = location.pathname === '/tags' || location.pathname.startsWith('/tags/')
    const isSearch     = location.pathname.startsWith('/search/')
    const isFavourites = location.pathname.startsWith('/favourites')

    let selectedTags: string[] = []
    if (isTagList) {
        const path = location.pathname.replace(/^\//, '')
        selectedTags = path.split('/')[1]?.split(',').map(t => decodeURIComponent(t.trim())).filter(Boolean) || []
    }

    const directoryFilter = (d: VideoDirectory) =>
        !d.name.startsWith('.') && (!!d.fileCount || !!d.childCount)

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        navigate(`/search/${searchTerm}`)
    }

    const sortTags = (a: string, b: string) => a.toLowerCase() > b.toLowerCase() ? 1 : -1
    const filterTag = (t: string) => t.toLowerCase().includes(tagSearchTerm.toLowerCase())

    return (
        <div className="file-browser">

            {/* ── Tags page ── */}
            {isTagList && (
                <div className="fb-tags-filter">
                    <div className="fb-tags-header">
                        <button
                            className={'fb-mode-btn' + (!tagManageMode ? ' active' : '')}
                            onClick={() => setTagManageMode(false)}
                        >Browse</button>
                        <button
                            className={'fb-mode-btn' + (tagManageMode ? ' active' : '')}
                            onClick={() => setTagManageMode(true)}
                        >Manage</button>
                    </div>

                    {tagManageMode ? (
                        <TagManagement/>
                    ) : (
                    <>
                    <input
                        type="text"
                        placeholder="Filter tags…"
                        value={tagSearchTerm}
                        onChange={e => setTagSearchTerm(e.target.value)}
                    />
                    <div className="fb-tagcloud">
                        {tags.sort(sortTags).filter(filterTag).map(tag => (
                            <Link
                                key={tag}
                                to={`/tags/${tag}`}
                                className={'fb-tag-pill' + (selectedTags.includes(tag) ? ' selected' : '')}
                            >
                                {tag}
                                {selectedTags.length > 0 && (
                                    <span className="fb-tag-actions" onClick={e => e.preventDefault()}>
                                        {selectedTags.includes(tag) ? (
                                            <Link to={`/tags/${selectedTags.filter(t => t !== tag).join(',')}`}>
                                                <FontAwesomeIcon icon={faMinus}/>
                                            </Link>
                                        ) : (
                                            <Link to={`/tags/${[...selectedTags, tag].join(',')}`}>
                                                <FontAwesomeIcon icon={faPlus}/>
                                            </Link>
                                        )}
                                    </span>
                                )}
                            </Link>
                        ))}
                    </div>
                    </>
                    )}
                </div>
            )}

            {/* ── Search page ── */}
            {isSearch && (
                <form className="fb-search-form" onSubmit={onSearchSubmit}>
                    <input
                        type="text"
                        placeholder="Search…"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        disabled={dirLoading}
                        autoFocus
                    />
                    <button type="submit" disabled={dirLoading}>Search</button>
                </form>
            )}

            {selectedTags.length > 0 && (
                <div className="fb-selected-tags">
                    Filtered by: {selectedTags.join(', ')}
                </div>
            )}

            {!isTagList && !isSearch && !isFavourites && <ContinueWatching/>}

            {currentDir && <ClipList dir={currentDir.hash}/>}

            <DirectoryList loading={dirLoading} dirs={directories.filter(directoryFilter)}/>

            <VideoList
                canBeSelected={true}
                loading={dirLoading}
                files={files}
                showDirectory={selectedTags.length > 0 || isSearch || isFavourites}
            />
        </div>
    )
}
